module.exports = __webpack_public_path__ + "img/select-arrow.1263d6fa.svg";